import { Avatar, Card, CardContent, Checkbox, Chip, Divider, Icon, InputAdornment, List, ListItem, Paper, Popover, TextField, Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { Search } from "@material-ui/icons";
import GridItem from "components/Grid/GridItem.jsx";
import React from "react";
import { UserStatus } from "../../../enums/user_management.js";

class BaseTablePageContent extends React.Component {
  state = {
    filterEl: null
  };

  handlePopoverClose = name => {
    this.setState({
      [name]: null
    });
  };

  handlePopoverOpen = (event, name) => {
    this.setState({
      [name]: event.currentTarget
    });
  };

  calculateUserSlots = () => {
    let activeCount = { ...this.props.typeDetails.activeCount };
    let limit = { ...this.props.typeDetails.userLimits };
    let userSlots = [];

    Object.keys(activeCount).map(k => {
      let typename = k;
      typename = typename.charAt(0).toUpperCase() + typename.substring(1);
      userSlots.push({
        type: typename,
        slots: limit[k] - activeCount[k]
      });
      return k;
    });

    return userSlots;
  };

  render() {
    let userSlots = this.props.typeDetails ? this.calculateUserSlots() : null;
    return (
      <Grid container>
        <GridItem xs={12} sm={12} md={10} style={{flexBasis: "100%", maxWidth: "100%", margin: 'auto' }}>
          <Card>
            <CardContent>
              <div>
                <Typography variant="headline" className="centerCell">
                  {this.props.title}
                </Typography>
                <div
                  style={{
                    borderBottom: "1px solid #cccccc69",
                    margin: "5px auto",
                    width: "25%",
                    marginBottom: "20px"
                  }}
                />
              </div>
              <Grid
                container
                justify="space-between"
                style={{ marginBottom: "15px" }}
              >
                {this.props.typeDetails ? (
                  <Grid item xs={12} sm={12} md={4}>
                    {userSlots.map(u => {
                      return (
                        <Typography variant="caption" gutterBottom>
                          {u.type + " "}
                          Slots: <strong>{" " + u.slots}</strong>
                        </Typography>
                      );
                    })}
                  </Grid>
                ) : null}

                <Grid item xs={12} sm={12} md={2}>
                  <Paper
                    className="flabButton"
                    onClick={e => this.handlePopoverOpen(e, "filterEl")}
                  >
                    <div style={{ display: "flex" }}>
                      <Typography>Filter</Typography>
                      <Icon>arrow_drop_down</Icon>
                    </div>
                  </Paper>
                  <Popover
                    open={Boolean(this.state.filterEl)}
                    anchorEl={this.state.filterEl}
                    onClose={() => this.handlePopoverClose("filterEl")}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "center"
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "center"
                    }}
                  >
                    <List component="nav">
                      <ListItem
                        button
                        onClick={e =>
                          this.props.toggleFilterItem(UserStatus.Active)
                        }
                      >
                        <Checkbox
                          checked={this.props.filters.includes(
                            UserStatus.Active
                          )}
                          onChange={e =>
                            this.props.toggleFilterItem(UserStatus.Active)
                          }
                        />
                        <Typography
                          variant="subheading"
                          style={{
                            marginLeft: "10px",
                            marginRight: "10px"
                          }}
                        >
                          Active
                        </Typography>
                      </ListItem>

                      <Divider />
                      <ListItem
                        button
                        onClick={e =>
                          this.props.toggleFilterItem(UserStatus.Requested)
                        }
                      >
                        <Checkbox
                          checked={this.props.filters.includes(
                            UserStatus.Requested
                          )}
                          onChange={e =>
                            this.props.toggleFilterItem(UserStatus.Requested)
                          }
                        />
                        <Typography
                          variant="subheading"
                          style={{
                            marginLeft: "10px",
                            marginRight: "10px"
                          }}
                        >
                          Requested
                        </Typography>
                      </ListItem>
                      <Divider />
                      <ListItem
                        button
                        onClick={e =>
                          this.props.toggleFilterItem(UserStatus.Inactive)
                        }
                      >
                        <Checkbox
                          checked={this.props.filters.includes(
                            UserStatus.Inactive
                          )}
                          onChange={e =>
                            this.props.toggleFilterItem(UserStatus.Inactive)
                          }
                        />
                        <Typography
                          variant="subheading"
                          style={{
                            marginLeft: "10px",
                            marginRight: "10px"
                          }}
                        >
                          Inactive
                        </Typography>
                      </ListItem>
                    </List>
                  </Popover>
                </Grid>
              </Grid>

              <Paper style={{ overflowX: "auto" }}>
                <Grid container>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={10}
                    style={{ margin: "0 auto" }}
                  >
                    <Grid container>
                      <Grid
                        item
                        xs={6}
                        sm={4}
                        md={3}
                        style={{ margin: "25px auto 0px auto" }}
                      >
                        <Chip
                          avatar={
                            <Avatar
                              style={{
                                backgroundColor: "#6c5cab",
                                color: "white"
                              }}
                            >
                              <Icon>add</Icon>
                            </Avatar>
                          }
                          className="customChip"
                          variant="outlined"
                          label={
                            <Typography
                              style={{
                                color: "white"
                              }}
                            >
                              Invite Users
                            </Typography>
                          }
                          color="secondary"
                          style={{
                            backgroundColor: "#4239d659",
                            color: "white",
                            width: "100%"
                          }}
                          onClick={() => this.props.openInviteDialog()}
                        />
                      </Grid>
                    </Grid>

                    <TextField
                      id="input-with-icon-textfield"
                      fullWidth
                      style={{ padding: "30px" }}
                      placeholder="Search by Name, Surname, or Email"
                      onChange={this.props.handleSearch}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search />
                          </InputAdornment>
                        )
                      }}
                    />
                  </Grid>
                </Grid>
                {this.props.children}
              </Paper>
            </CardContent>
          </Card>
        </GridItem>
      </Grid>
    );
  }
}

export default BaseTablePageContent;



// WEBPACK FOOTER //
// ./src/views/UserManagement/components/BaseTablePageContent.jsx